import { forwardRef } from 'react'
import type { SelectHTMLAttributes, ReactNode } from 'react'
import { FormField, inputBaseStyles } from './FormField'

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'required'> {
  label?: string
  error?: string
  helperText?: string
  children: ReactNode
  required?: boolean
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, helperText, className = '', children, required, ...props }, ref) => {
    return (
      <FormField label={label} error={error} helperText={helperText} required={required} htmlFor={props.id}>
        <select
          ref={ref}
          className={inputBaseStyles(error, className)}
          aria-required={required}
          {...props}
        >
          {children}
        </select>
      </FormField>
    )
  }
)

Select.displayName = 'Select'

export default Select
